import { DateTime } from 'luxon'

export const oneWeekInMilliseconds = 604800000

export function scrollToError () {
  const yOffset = -100
  const errorElement = document.querySelector('.has-errors')
  if (errorElement) {
    const y = errorElement.getBoundingClientRect().top + window.scrollY + yOffset
    window.scrollTo({ top: y, behavior: 'smooth' })
  } else {
    // lets check for buckets selection error
    const errorLabelElement = document.querySelector('.error-label')
    if (errorLabelElement) {
      const y = errorLabelElement.getBoundingClientRect().top + window.scrollY + yOffset
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
  }
}

export function hasInvalidateSpecialCharacters (value: string): boolean {
  // Only allow alphanumeric, hyphens “-”, brackets “()”, forward slashes “/”, underscores “_”, and fullstops
  const allowedCharsRegex = /^[\w\-()/.() \s]+$/

  if (value !== '' && !allowedCharsRegex.test(value)) {
    return true
  } else {
    return false
  }
}

export function toSentenceCase (value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
}

export function getApiUTCDateTimeString (date: Date): string {
  const selectedDateLuxon = DateTime.fromJSDate(date).toUTC()
  const dateStr = selectedDateLuxon.toFormat('yyyy-MM-dd\'T\'HH:mm:ss') + 'Z'
  return dateStr
}

/**
 * Scrolls to an element smoothly
 * @param selector - CSS selector string (e.g., '.class', '#id', 'element')
 * @param offset - pixels above the element to leave visible (default 0)
 */
export function scrollIntoView (selector: string, offset = 0) {
  const element = document.querySelector(selector)
  if (!element) return
  if (offset > 0) {
    const top = element.getBoundingClientRect().top + window.scrollY - offset
    window.scrollTo({ top, behavior: 'smooth' })
  } else {
    element.scrollIntoView({ behavior: 'smooth' })
  }
}
